import {Injectable} from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

// DJ-contest area is open to super admins and users holding the "dj_contest_manager" role.
@Injectable({providedIn: 'root'})
export class DjContestGuard {
  constructor(private http: HttpClient, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.http
      .get<{is_super_admin?: boolean; roles?: string[]}>('rest-api/v1/admin/task-management/admins/me')
      .pipe(
        map(me =>
          me?.is_super_admin || me?.roles?.includes('dj_contest_manager')
            ? true
            : this.router.createUrlTree(['/admin/kpi-overview']),
        ),
        catchError(() => of(this.router.createUrlTree(['/admin/login']))),
      );
  }
}
